
import './App.css';
import Footer from './pages/Footer';
import TokenTransfer from './pages/inter';


function App() {
  return (
    <div className="App">
      <TokenTransfer/>
    </div>
  );
}
export default App;
